import React from 'react';
const Ajustes = () => (<h1>Cameras pessoais</h1>)

export default Ajustes;



// WEBPACK FOOTER //
// ./src/containers/Ajustes.js